import { getRequest } from '../services/requestHandler';
import { TourBagHistoryModel } from '../models';

export const getTourBagHistory = async (id: number) => {
  const url = `tourbag/getTourBagHistory?tourbagMstrid=${id}`;
  const response = await getRequest<TourBagHistoryModel>('GetTourBagHistory', url);
  return response;
};
